import React from "react";
import styled from "styled-components";

import AppWindow from "./window-styled-container";

const Window = styled(AppWindow)`
    padding: 2.5em;
    margin: 0 auto;
    margin-bottom: 2.5rem; /* ? */

    /* width: 100%; */
    max-width: 650px;

    color: var(--kpum-black);
`;

const ListItemWrapper = styled.div`
    max-width: 60ch;
    margin: 0 auto;
`;

const Title = styled.h1`
    font-family: var(--qanelas-main);
    font-size: 2.5em;
    font-weight: 400;
    margin: 0;
`;

const ItemGroup = styled.ol`
    margin: 0;
    padding: 0;
    counter-reset: nomor;
`;

const markerSize = 2;
const lineHeight = 1.25;

/* Here comes the magic (this is some heavy math shit right here) */
const outPadding = `calc(calc(${markerSize + "em"} - ${lineHeight + "em"}) / 2)`;

const Item = styled.li`
    list-style: none;
    counter-increment: nomor;

    display: flex;
    align-items: flex-start;

    line-height: ${lineHeight};

    margin-top: calc(${outPadding} + 1em);

    font-weight: 500;

    &::before {
        display: flex;
        align-items: center;
        justify-content: center;

        content: counter(nomor);
        font-weight: bold;

        width: ${markerSize + "em"};
        height: ${markerSize + "em"};
        border-radius: 50%;

        margin-top: calc(-1 * ${outPadding});
        margin-right: 0.5em;

        flex-shrink: 0;

        color: white;
        background-color: var(--kpum-black);

        ${props => props.markerCSS}
    }

    position: relative;

    /* Divider lines (FIXME) */
    &:not(:last-child)::after {
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        background-color: currentColor;
        opacity: 0.2;
        position: absolute;
        left: 0;
        bottom: -0.5em; /* FIXME */
    }
`;

const ListWindow = ({ style, titleStyle, markerCSS, className, title, contents }) => (
    <Window style={style} className={className}>
        <ListItemWrapper>
            <Title style={titleStyle}>{title}</Title>
            <ItemGroup>
                {contents.map((item) => (<Item markerCSS={markerCSS}>{item}</Item>))}
            </ItemGroup>
        </ListItemWrapper>
    </Window>
);

export default ListWindow;